import { taskSortButtons } from '../../common/tasks/tasksList/sortButtons/constants'

const defaultSortId = taskSortButtons[0].id

const defaultTabs: TaskTab[] = [
   {
      id: 'all',
      label: 'All',
   },
]

const defaultTabId = defaultTabs[0].id

const actionsTabs: TaskTab[] = [
   ...defaultTabs,
   {
      id: 'borrow',
      label: 'Borrow',
   },
   {
      id: 'return',
      label: 'Return',
   },
]

const remindersTabs: TaskTab[] = [
   ...defaultTabs,
   {
      id: 'this-week',
      label: 'This Week',
   },
   {
      id: 'overdue',
      label: 'Overdue',
   },
   {
      id: 'next-week',
      label: 'Next Week',
   },
]

const infoTabs: TaskTab[] = [
   ...defaultTabs,
   {
      id: 'warranty',
      label: 'Warranty',
   },
   {
      id: 'due-back',
      label: 'Due Back',
   },
]

enum TaskTypes {
   ConnectionRequest = 0,
   AcceptConnectionRequest = 1,
   DeclineConnectionRequest = 2,
   BorrowToolRequest = 10,
   AcceptedBorrowToolRequest = 11,
   DeclineBorrowToolRequest = 12,
   LoanToolRequest = 20,
   AcceptedLoanToolRequest = 21,
   DeclineLoanToolRequest = 22,
   ReturnRequest = 30,
   AcceptedReturnRequest = 31,
   DeclineReturnRequest = 32,
   ReturnRequestNoResponse = 33,
   TransferToolToRequest = 40,
   TransferToolFromRequest = 50,
   MassTransfer = 91,
   CustomFieldReminder = 61,
   RentalDueDateReminder = 71,
   ToolDueDateReminder = 81,
   ToolNoteCreated = 1002,
   ToolNoteDueDateReminder = 1001,
   ToolWarrantyReminder = 1003,
   ToolCreateReminder = 1004,
   ReorderLevelReminder = 1005,
   SmartAuditNotification = 1006,
}

export {
   defaultSortId,
   defaultTabId,
   defaultTabs,
   actionsTabs,
   remindersTabs,
   infoTabs,
   TaskTypes,
}
